import palette from '../theme/palette';

const variants = [
  {
    props: { color: 'internal' },
    style: {
      color: palette.internal.main,
      '&.MuiToggleButton-root': {
        borderColor: palette.internal.main,
      },
    },
  },
];

export default variants;
